// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import ActionSheetController from "./action_sheet_controller";
application.register("action-sheet", ActionSheetController);

import ActionSheetTriggerController from "./action_sheet_trigger_controller";
application.register("action-sheet-trigger", ActionSheetTriggerController);

import AdminDeleteConfirmationController from "./admin_delete_confirmation_controller";
application.register(
  "admin-delete-confirmation",
  AdminDeleteConfirmationController,
);

import AllergenPickerController from "./allergen_picker_controller";
application.register("allergen-picker", AllergenPickerController);

import AnalyticsAreaChartController from "./analytics_area_chart_controller";
application.register("analytics-area-chart", AnalyticsAreaChartController);

import AnalyticsHoursChartController from "./analytics_hours_chart_controller";
application.register("analytics-hours-chart", AnalyticsHoursChartController);

import AppTourController from "./app_tour_controller";
application.register("app-tour", AppTourController);

import BillingToggleController from "./billing_toggle_controller";
application.register("billing-toggle", BillingToggleController);

import BottomSheetController from "./bottom_sheet_controller";
application.register("bottom-sheet", BottomSheetController);

import BottomSheetTriggerController from "./bottom_sheet_trigger_controller";
application.register("bottom-sheet-trigger", BottomSheetTriggerController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import ComboboxController from "./combobox_controller";
application.register("combobox", ComboboxController);

import ConfettiController from "./confetti_controller";
application.register("confetti", ConfettiController);

import ConfirmModalController from "./confirm_modal_controller";
application.register("confirm-modal", ConfirmModalController);

import ConversionEventDetailController from "./conversion_event_detail_controller";
application.register(
  "conversion-event-detail",
  ConversionEventDetailController,
);

import ConversionTrackerController from "./conversion_tracker_controller";
application.register("conversion-tracker", ConversionTrackerController);

import DialogTriggerController from "./dialog_trigger_controller";
application.register("dialog-trigger", DialogTriggerController);

import DismissableController from "./dismissable_controller";
application.register("dismissable", DismissableController);

import DrawerController from "./drawer_controller";
application.register("drawer", DrawerController);

import DrawerTriggerController from "./drawer_trigger_controller";
application.register("drawer-trigger", DrawerTriggerController);

import EditorDrawerController from "./editor_drawer_controller";
application.register("editor-drawer", EditorDrawerController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import InlineEditController from "./inline_edit_controller";
application.register("inline-edit", InlineEditController);

import JourneyDetailController from "./journey_detail_controller";
application.register("journey-detail", JourneyDetailController);

import MenuImportController from "./menu_import_controller";
application.register("menu-import", MenuImportController);

import MobileNotificationDropdownController from "./mobile_notification_dropdown_controller";
application.register(
  "mobile-notification-dropdown",
  MobileNotificationDropdownController,
);

import MobilePanelController from "./mobile_panel_controller";
application.register("mobile-panel", MobilePanelController);

import MobilePanelTriggerController from "./mobile_panel_trigger_controller";
application.register("mobile-panel-trigger", MobilePanelTriggerController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import NotificationDropdownController from "./notification_dropdown_controller";
application.register("notification-dropdown", NotificationDropdownController);

import OpeningHoursController from "./opening_hours_controller";
application.register("opening-hours", OpeningHoursController);

import PhotoUploadController from "./photo_upload_controller";
application.register("photo-upload", PhotoUploadController);

import PlacesLookupController from "./places_lookup_controller";
application.register("places-lookup", PlacesLookupController);

import PreviewDeviceController from "./preview_device_controller";
application.register("preview-device", PreviewDeviceController);

import PriceInputController from "./price_input_controller";
application.register("price-input", PriceInputController);

import RemoteFormController from "./remote_form_controller";
application.register("remote-form", RemoteFormController);

import SaveIndicatorController from "./save_indicator_controller";
application.register("save-indicator", SaveIndicatorController);

import ScanChartController from "./scan_chart_controller";
application.register("scan-chart", ScanChartController);

import SortableCategoriesController from "./sortable_categories_controller";
application.register("sortable-categories", SortableCategoriesController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import ThemePickerController from "./theme_picker_controller";
application.register("theme-picker", ThemePickerController);

import ToastController from "./toast_controller";
application.register("toast", ToastController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import TrackingDetailController from "./tracking_detail_controller";
application.register("tracking-detail", TrackingDetailController);

import TranslatePollController from "./translate_poll_controller";
application.register("translate-poll", TranslatePollController);
